'use client';
import { filterProps } from './core.utils.js';
import { renderElem } from './render-element.util.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

function RenderComp({ root, props, propKeysToRemove, forwardedRef, classNames, children }) {
    const classNameIter = processStyleProps(props, classNames);
    const forwardedProps = filterProps(props, propKeysToRemove, classNameIter);
    return renderElem({
        root,
        ref: forwardedRef,
        renderProps: props,
        props: forwardedProps,
        children
    });
}

export { RenderComp };
